import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/locales/i18n'
// import store from "../store";
// import { routerIsParamsOrQuery } from "../utils/router";

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const pages = [
  {
    path: '/business-dispatch',
    name: 'business-dispatch',
    meta: { title: i18n.t('sidemenu.businessScheduling') },
    component: () => import('../views/business-dispatch/business-dispatch.vue')
  },
  {
    path: '/driver-list',
    name: 'driver-list',
    meta: { title: i18n.t('sidemenu.driverManagement') },
    component: () => import('../views/driver-list/driver-list.vue')
  },
  {
    path: '/location-list',
    name: 'location-list',
    meta: { title: i18n.t('sidemenu.factoryManagement') },
    component: () => import('../views/location-list/location-list.vue')
  },
  {
    path: '/customer-list',
    name: 'customer-list',
    meta: { title: i18n.t('sidemenu.customerManagement') },
    component: () => import('../views/customer-list/customer-list.vue')
  },
  // {
  //   path: '/companyUser-list',
  //   name: 'companyUser-list',
  //   meta: { title: '公司列表' },
  //   component: () => import('../views/companyUser-list/companyUser-list.vue')
  // },
  {
    path: '/user-list',
    name: 'user-list',
    meta: { title: i18n.t('sidemenu.userManagement') },
    component: () => import('../views/user-list/user-list.vue')
  },
  {
    path: '/truck-list',
    name: 'truck-list',
    meta: { title: i18n.t('sidemenu.vehicleManagement') },
    component: () => import('../views/truck-list/truck-list.vue')
  },
  {
    path: '/receivable-list',
    name: 'receivable-list',
    meta: { title: i18n.t('sidemenu.receivableDetails') },
    component: () => import('../views/receivable-list/receivable-list.vue')
  },
  {
    path: 'bills-receivable',
    name: 'bills-receivable',
    meta: { title: i18n.t('sidemenu.billsReceivable') },
    component: () => import('../views/bills-receivable/bills-receivable.vue')
  }
]


const routes = [
  {
    path: '/',
    name: 'main',
    meta: { title: '首页', keepAlive: true, icon: 'search' },
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '首页' },
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../components/index.vue'),
    meta: { title: i18n.t('sidemenu.basicInformation') },
    redirect: '/business-dispatch',
    children: pages
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login',
    component: () => import('../views/login/login.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// router.beforeEach((to, from, next) => {
//   if (to.path === "/login" || to.path === "/") {
//     return next();
//   }
//   const { originalPath } = routerIsParamsOrQuery(to);
//   const pageTabs = store.getters.getPageTabs;
//   const isExist = pageTabs.some(item => item.path === originalPath);
//   store.commit("setCurrentTabKey", originalPath);
//   if (!isExist) {
//     store.commit("setPageTabs", [...pageTabs, { path: originalPath, title: to.meta.title }]);
//   }
//   next();
// })

export default router
